<template>
  <div class="mt-5 mb-5 ml-auto mr-auto" :key="componentKey" style="min-height: 83.1875rem;">
    <div class="container">
      <!-- Skeleton for Profile Alert -->
      <div v-if="isLoading" class="skeleton skeleton-alert mb-3"></div>
      <div v-else-if="showCompleteProfileAlert">
        <div class="alert alert-warning" role="alert">
          Please complete your profile first. Click Here to <router-link to="/employer-profile"
            class="custom-text-color text-decoration-none"><i>Update Your Profile.</i></router-link>
        </div>
      </div>
      <div class="style-spacer"></div>
      <div class="style-spacer"></div>
      <div v-if="showDashboard">
        <div class="row no-gutters w-100 mt-2">
          <!-- Skeleton for Left Profile Card -->
          <div class="col-md-2" style="margin-left: 20px; margin-right: 20px">
            <div v-if="isLoading" class="skeleton skeleton-card h-100"></div>
            <div v-else class="card p-0 mb-20 w3-center custom-profile-card h-100"
              style="background-color: white; color:black;">
              <div class="card-body pt-4 pb-4">
                <div>
                  <div class="custom-profile-image-wrap custom-company-image-wrap">
                    <div v-if="body.companyLogoAddress !== null">
                      <img :src="url + body.companyLogoAddress" alt="" class="custom-profile-image">
                    </div>
                    <div v-else>
                      <img src="../../assets/images/no-image.png" alt="" class="w3-circle custom-profile-image">
                    </div>
                  </div>
                </div>
                <div class="w3-center custom-profile-detail">
                  <h5 class="font-weight-bold text-capitalize">
                    {{ body.companyName }}
                  </h5>
                </div>
              </div>
              <div class="card-footer border-0 pl-0 pr-0">
                <div class="custom-profile-contacts custom-profile-detail">
                  <div>
                    <a class="text-decoration-none w3-hover-text-light-gray"
                      :href="phoneNumberLink + body.contactNumber">
                      <span><i class="fas fa-phone-alt fa-md fa-fw mr-2"></i></span>
                      <span class="">{{ body.contactNumber }}</span>
                    </a>
                  </div>
                  <div>
                    <a class="text-decoration-none w3-hover-text-light-gray" :href="emailLink + body.companyEmail">
                      <i class="fas fa-envelope fa-md fa-fw mr-2"></i>
                      <span>{{ body.companyEmail }}</span>
                    </a>
                  </div>
                </div>
                <div class="custom-row justify-content-center mt-2">
                  <a :href="'https://' + body.facebookLink" target="_blank"
                    class="custom-facebook-icon custom-icon-style mr-2 custom-social-link">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a :href="'https://' + body.googlePlusLink" target="_blank"
                    class="custom-googleplus-icon custom-icon-style mr-2 custom-social-link">
                    <i class="fab fa-google"></i>
                  </a>
                  <a :href="'https://' + body.linkedInLink" target="_blank"
                    class="custom-linkedin-icon custom-icon-style mr-2 custom-social-link">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                  <a :href="'https://' + body.twitterLink" target="_blank"
                    class="custom-twitter-icon custom-icon-style custom-social-link">
                    <i class="fab fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Main Content -->
          <div class="col-md-7" style="margin-top: 50px; margin-right: 20px">
            <!-- Skeleton for CV Search -->
            <div v-if="isLoading" class="skeleton skeleton-search mb-3"></div>
            <div v-else style="margin-bottom: 20px;">
              <label for="Search" style="font-weight: bolder;font-size: larger;">CV SEARCH</label>
              <div class="input-group custom-search-input">
                <div class="input-group-prepend">
                  <span class="input-group-text custom-input-group-icon" id="basic-addon1"><b-icon
                      icon="Search"></b-icon></span>
                </div>
                <input type="text" class="form-control custom-filter-input form-control-sm" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon1" v-model="currentSalary" />
                <button @click="navigateWithQuery" style="background-color: rgb(236, 34, 31);
                  border: 1px rgb(241, 158, 220);
                  border-radius: 5%;
                  color: white;
                  height: 33px;
                  width: 101px;
                  margin-left: 10px;">SEARCH</button>
              </div>
            </div>
            <!-- Skeleton for Stats Cards -->
            <div class="row" v-if="isLoading">
              <div class="col-lg-3 col-md-6" v-for="n in 4" :key="n">
                <div class="skeleton skeleton-stats-card h-100"></div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-lg-3 col-md-6">
                <div class="card h-100">
                  <div class="card-body pb-0">
                    <h4 class="mb-1 mt-1">
                      <span data-plugin="counterup" v-if="dashboardData.jobStats.totalJobs">{{
                        dashboardData.jobStats.totalJobs }}</span>
                      <span data-plugin="counterup" v-else>0</span>
                    </h4>
                  </div>
                  <div class="card-footer bg-white border-0 pt-0 text-muted" style="font-size: 18px">
                    Total Jobs
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="card h-100">
                  <div class="card-body pb-0">
                    <h4 class="mb-1 mt-1">
                      <span data-plugin="counterup">{{ dashboardData.jobStats.cVsRecieved }}</span>
                    </h4>
                  </div>
                  <div class="card-footer bg-white border-0 pt-0 text-muted" style="font-size: 18px">
                    Received CVs
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="card h-100">
                  <div class="card-body pb-0">
                    <h4 class="mb-1 mt-1">
                      <span data-plugin="counterup">{{ dashboardData.jobStats.shortlistedCandidates }}</span>
                    </h4>
                  </div>
                  <div class="card-footer bg-white border-0 pt-0 text-muted" style="font-size: 18px">
                    Candidates shortlisted
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6">
                <div class="card h-100">
                  <div class="card-body pb-0">
                    <h4 class="mb-1 mt-1">
                      <span data-plugin="counterup">{{ dashboardData.jobStats.upcomingInterviews }}</span>
                    </h4>
                  </div>
                  <div class="card-footer bg-white border-0 pt-0 text-muted" style="font-size: 18px">
                    Upcoming interviews
                  </div>
                </div>
              </div>
            </div>
            <!-- Post a Job Button -->
            <div class="row" v-if="!isLoading">
              <div class="col-md-12"
                style="display: flex; justify-content: center; margin-top: 31px; margin-bottom: 20px;">
                <button style="background-color: rgb(236, 34, 31);
                  border: 1px rgb(241, 158, 220);
                  border-radius: 5%;
                  color: white;
                  height: 40px;
                  width: 130px;
                  margin-left: 10px;">
                  <router-link style="color: white; font-weight: bolder;" to="/employer-postjob/0">
                    Post A Job
                  </router-link>
                </button>
              </div>
            </div>
          </div>
          <!-- Skeleton for Right Profile Card -->
          <div class="col-md-2" style="margin-left: 20px;">
            <div v-if="isLoading" class="skeleton skeleton-card h-100"></div>
            <div v-else class="card p-0 mb-20 w3-center h-100">
              <div class="card-body pt-4 pb-4">
                <div>
                  <div class="custom-profile-image-wrap">
                    <div v-if="disEmployeeLogo !== null">
                      <img :src="url + disEmployeeLogo" alt="" class="rounded-circle custom-profile-image">
                    </div>
                    <div v-else>
                      <img src="../../assets/images/no-image.png" alt="" class="w3-circle custom-profile-image">
                    </div>
                  </div>
                </div>
                <div class="w3-center text-dark">
                  <h5 class="font-weight-bold text-capitalize">
                    {{ body.fullName }}
                  </h5>
                  <div>
                    <span>{{ body.designation }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Recent Applicants -->
          <div style="width: 100%;">
            <div style="display: grid; justify-content: center; padding: 5%;">
              <span style="font-size: x-large; font-weight: bolder;">Recent Applicants</span>
            </div>
            <div style="float:left; width: 63%;">
              <!-- Skeleton for Recent Applicants -->
              <div class="col-md-12 mb-2" v-if="isLoading" v-for="n in 3" :key="n">
                <div class="skeleton skeleton-applicant"></div>
              </div>
              <!-- Show this block if there are applicants -->
<div v-if="arrays.length != 0">
  <div class="col-md-12 mb-2" v-for="appli in arrays" :key="appli.jobApplicantsId">
    <div class="card p-3 recent-applications" style="background-color: #ffe6e6; border-radius: 10px;">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-0">{{ appli.empName }}</h5>
          <p class="mb-0">{{ appli.jobTitle }}</p>
        </div>
        <div>
          <span class="badge badge-primary">{{ appli.applicantStatus }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-2">
        <div>
          <span>{{ appli.appliedDate | formatDate }}</span>
        </div>
        <router-link :to="{ name: 'CandidatesApplied', params: { id: appli.jobId, empId: appli.empId } }"
          class="btn btn-primary">View Profile</router-link>
      </div>
    </div>
  </div>
</div>

<!-- Show this if there are no applicants -->
<div v-else class="text-center mt-4">
  <h5>No applicant found</h5>
</div>


              </div>
            </div>
            <!-- See More Button -->
            <div style="display: flex; justify-content: space-around; margin-top: 10px; width:100%;" v-if="!isLoading">
              <router-link to="/employer-candidates/0">
                <button style="background-color: rgb(236, 34, 31);
                border: 1px rgb(241, 158, 220);
                border-radius: 73px;
                color: white;
                height: 45px;
                width: 135px;
                margin-left: 10px;">See More ⮷</button>
              </router-link>
            </div>
            <div class="pt-4"></div>
            <div class="m-4" style="width: 75rem;">
              <!-- Skeleton for Charts -->
              <div class="row no-gutters" v-if="isLoading">
                <div class="col-lg-6">
                  <div class="skeleton skeleton-chart"></div>
                </div>
                <div class="col-lg-6">
                  <div class="skeleton skeleton-chart"></div>
                </div>
              </div>
              <div v-else>
                <div class="row no-gutters">
                  <div class="col-lg-6">
                    <div class="w3-card-2 h-100">
                      <div class="card-body">
                        <div style="">
                          <div class="col-sm-6">Start Date
                            <input type="date" class="form-control" autocomplete="off" required=""
                              v-model="chartStartDate" :class="{
                              'is-invalid':
                                submitted && $v.body.establishedIn.$error,
                            }" />
                          </div>
                          <div class="col-sm-6">End Date
                            <input type="date" class="form-control" autocomplete="off" required=""
                              v-model="chartEndDate" :class="{
                              'is-invalid':
                                submitted && $v.body.establishedIn.$error,
                            }" />
                          </div>
                        </div>
                        <h4 class="card-title mb-4 text-center">
                          CVs recieved on my jobs
                        </h4>
                        <apexchart width="100%" type="bar" :options="lineChartOptions" :series="lineChartSeries">
                        </apexchart>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <apexchart type="donut" :options="chartOptions" :series="series" width="100%"></apexchart>
                  </div>
                </div>
              </div>
              <div class="style-spacer"></div>
              <div class="style-spacer"></div>
            </div>
          </div>
        </div>
        <!-- My Jobs Section -->
        <div style="background-color: #ff4285; color: white;" v-if="isLoading" class="skeleton"></div>
        <div style="background-color: #ff4285; color: white;" v-else>
          <label
            style="margin-left: 20px; padding: 10px; font-size: larger; font-weight: bolder; text-decoration: underline;">My
            Job</label>
        </div>
        <div>
          <!-- Skeleton for Jobs -->
          <div class="row mt-30" v-if="isLoading">
            <div class="col-md-6" v-for="n in 4" :key="n">
              <div class="skeleton skeleton-job"></div>
            </div>
          </div>
          <div class="row mt-30" v-else>
            <div class="col-md-6" v-for="(job, index) in arrays1.slice().reverse()" :key="job.jobId">
              <div class="custom-job-height w3-card-2 p-3">
                <div class="row">
                  <div class="col-lg-12">
                    <h4 class="custom-job-title custom-text-color text-capitalize">
                      {{ job.jobTitle }}
                    </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <b>{{ job.city }}</b> - <b>{{ job.countryName }}</b>
                    </p>
                    <span class="offersalary">
                      Offer Salary:
                      <span v-if="job.packageTo === 0 || job.packageTo === 1">
                        Market Competitive Salary
                      </span>
                      <span v-else>
                        Rs. {{ job.packageFrom }} - {{ job.packageTo }}
                      </span>
                    </span>
                  </div>
                  <div class="col-md-6">
                    <p class="job-posted">
                      Job Posted: {{ job.insertionDate | moment1 }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="job-posted">
                      Job Expiry: {{ job.jobExpiryDate | moment1 }}
                    </p>
                  </div>
                  <div class="col-md-7">
                    <router-link :to="{
                    name: 'CandidatesApplied',
                    params: { id: job.jobId, empId: job.applicantEmployeeId },
                  }" type="button" class="btn btn-primary">View Applicants</router-link>
                    <br />
                    <router-link class="jobbutton" :to="{ name: 'JobDetail', params: { id: job.jobId } }">
                      <span><i class="fas fa-file"></i></span><span> View</span>
                    </router-link>
                    <router-link :to="{ name: 'EmployerPostJob', params: { id: job.jobId } }">
                      <span><i class="fas fa-pencil-square-o"></i></span><span> Edit</span>
                    </router-link>
                    <br />
                    <a class="jobbutton" href="">
                      <span><i class="fas fa-power-off"></i></span><span> Deactivate</span>
                    </a>
                  </div>
                  <div class="col-md-5">
                    <button type="button" class="btn btn-primary">
                      Instant Match
                    </button>
                    <br />
                    <a class="jobbutton" href="">
                      <span><i class="fas fa-link"></i></span><span> Attach Course </span>
                    </a>
                    <a :id="'popover-target-' + index" class="jobbutton" href="javascript:void(0)">
                      <span><i class="fas fa-share-alt"></i></span><span> Share</span>
                    </a>
                    <b-popover :target="'popover-target-' + index" triggers="hover" placement="bottom">
                      <div class="custom-row justify-content-center mt-2">
                        <a :href="whatsAppUrl + encodeURIComponent(domainUrl + '/#/' + job.jobId)" type="url"
                          target="_blank" class="custom-whatsapp-icon custom-icon-style mr-2 custom-social-link">
                          <i class="fab fa-whatsapp"></i>
                        </a>
                        <ShareNetwork class="custom-facebook-icon custom-icon-style mr-2 custom-social-link"
                          network="facebook" :url="domainUrl + '/#' + job.jobId" :title="job.jobTitle"
                          :description="job.jobDescription">
                          <i class="fab fa-facebook-f"></i>
                        </ShareNetwork>
                        <ShareNetwork class="custom-linkedin-icon custom-icon-style custom-social-link"
                          network="linkedin" :url="domainUrl + '/#' + job.jobId" :title="job.jobTitle"
                          :description="job.jobDescription">
                          <i class="fab fa-linkedin-in"></i>
                        </ShareNetwork>
                      </div>
                    </b-popover>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <!-- See More Button -->
          <div style="display: flex; justify-content: center; margin-top: 10px;" v-if="!isLoading">
            <router-link to="/employer-jobs">
              <button style="background-color: rgb(236, 34, 31);
              border: 1px rgb(241, 158, 220);
              border-radius: 73px;
              color: white;
              height: 45px;
              width: 135px;
              margin-left: 10px;">See More ⮷</button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row no-gutters w-100 mt-4">
        <div class="col-md-2"></div>
        <div class="col-md-8"></div>
        <div class="col-md-2"></div>
      </div>
      <!-- Modal -->
      <div class="modal fade custom-modal" id="showDetailModal" tabindex="-1" role="dialog"
        aria-labelledby="showDetailModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="showDetailModalTitle">{{ modalTitle }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="isTutorialGuideVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isMumsBacktoWorkVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isAbledCandidatesVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isFreshGraduateVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isRemoteVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isViiLearnVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
              <div v-if="isShehriDirectoryVisible">
                <p style="text-align: justify;">{{ modalcontent }}</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { ArrowLeftCircleIcon } from "vue-feather-icons";
import { ArrowRightCircleIcon } from "vue-feather-icons";
import { VueperSlide, VueperSlides } from "vueperslides";
import CvSearch from '../employer/CvSearch.vue';
import EmpCandidates from '../employer/Candidates.vue';
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  name: "EmployerDashboard",
  components: {
    VueSlickCarousel,
    ArrowLeftCircleIcon,
    ArrowRightCircleIcon,
    CvSearch,
    EmpCandidates
  },
  data() {
    const currentDate = new Date();
    const startDate = new Date(currentDate);
    startDate.setMonth(currentDate.getMonth() - 3);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return {
      isLoading: true, // Add isLoading state
      chartStartDate: formatDate(startDate),
      chartEndDate: formatDate(currentDate),
      whatsAppUrl: "",
      url: axios.defaults.baseURL,
      modalTitle: "",
      modalcontent: "",
      currentSalary: null,
      isTutorialGuideVisible: false,
      isMumsBacktoWorkVisible: false,
      isAbledCandidatesVisible: false,
      isFreshGraduateVisible: false,
      isRemoteVisible: false,
      isViiLearnVisible: false,
      isShehriDirectoryVisible: false,
      showDashboard: false,
      showCompleteProfileAlert: false,
      arrays: [],
      jobTitleCounts: [],
      jobTitlename: [],
      arrays1: [],
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
        },
        labels: ['Female', 'Male', 'Transgender'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      lineChartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            show: false,
          },
          theme: {
            palette: 'palette1'
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "45%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        colors: ["#5b73e8", "#f1b44c"],
        grid: {
          borderColor: "#f1f1f1",
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (e) {
              return Math.round(e);
            },
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 6,
        },
      },
      lineChartSeries: [
        {
          name: "CVs Received",
          data: [],
        },
      ],
      phoneNumberLink: "tel:",
      emailLink: "mailto:",
      employerList: null,
      disCompanyLogo: "",
      dashboardData: {
        jobStats: {
          totalJobs: 0,
          cVsRecieved: 0,
          shortlistedCandidates: 0,
          upcomingInterviews: 0
        },
        cVsRecievedOnJobs: []
      },
      disEmployeeLogo: null,
      packages: [],
      isPackageDataFetched: false,
      body: {
        employerCompanyId: 0,
        companyEmail: "",
        companyName: "",
        companyLogoAddress: null,
        ceoName: "",
        employeeId: this.$auth.user().employeeId,
        industryId: 0,
        ownerShipTypeId: 0,
        companyDesciption: "",
        countryId: 106,
        cityId: 0,
        address: "",
        establishedIn: "",
        websiteUrl: "",
        contactNumber: "",
        googleMapIframe: "",
        linkedInLink: "",
        facebookLink: "",
        googlePlusLink: "",
        twitterLink: "",
        employeeImage: "",
        fullName: "",
        email: "",
        mobileNumber: null,
        designation: "",
      },
      bodyJobFilter: {
        ApplicantStatus: 0,
        PageNumber: 0,
        PageSize: 0
      },
      bodyJobFilter1: {
        ExpiredJobsOnly: 0,
        jobStatus: 3
      },
      allJobsList: null,
      componentKey: 0,
    };
  },
  computed: {
    employerDashboardLeftSide() {
      return this.$store.getters.availableEmployerDashboardLeftSide;
    },
    employerDashboardRightSide() {
      return this.$store.getters.availableEmployerDashboardRightSide;
    },
    employerDashboardCenter() {
      return this.$store.getters.availableEmployerDashboardCenter;
    }
  },
  watch: {
    chartStartDate(newDate) {
      if (newDate && this.chartEndDate) {
        this.getGraphData();
      }
    },
    chartEndDate(newDate) {
      if (newDate && this.chartStartDate) {
        this.getGraphData();
      }
    }
  },
  methods: {
    getJobInfo(js) {
      this.arrays1 = [];
      this.isLoading = true;
      if (Number(js) === 99) {
        this.bodyJobFilter1.ExpiredJobsOnly = 1;
        this.bodyJobFilter1.jobStatus = 0;
      } else {
        this.bodyJobFilter1.ExpiredJobsOnly = 0;
        this.bodyJobFilter1.jobStatus = Number(js);
      }

      const payload = {
        ...this.bodyJobFilter1,
        includeApplicant: true,
      };

      axios
        .post('/api/EmployerCompany/GetFilteredJobs', payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            console.log("Error: Failed to fetch data.");
            throw new Error("Failed to fetch data");
          }

          let resdata = res.data.data;
          let top4Records = resdata.slice(0, 4);
          this.arrays1 = top4Records;
          this.isLoading = false;
          this.arrays1.length === 0 ? this.showAlert() : this.hideAlert();
        })
        .catch((error) => {
          console.log("Error: ", error);
          this.isLoading = false;
        });
    },
    getProfileInfo(js) {
      this.arrays = [];
      this.isLoading = true;
      this.bodyJobFilter.ApplicantStatus = Number(js);
      this.bodyJobFilter.PageSize = 3;
      this.bodyJobFilter.PageNumber = 1;

      axios
        .post("/api/EmployerCompany/GetFilteredCandidates", this.bodyJobFilter)
        .then((res) => {
          if (res.status !== 200) {
            console.log("error.....");
            throw new Error("Failed to fetch!");
          }

          let resdata = res.data.data.data;
          if (resdata.length > 0) {
            let top3Records = resdata.slice(0, 3);
            this.arrays = top3Records;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    navigateWithQuery() {
      this.$router.push({
        name: 'CvSearch',
        query: { currentSalary: this.currentSalary }
      });
    },
    getAdds() {
      this.$store.dispatch("fetchAdds");
    },
    getAll() {
      this.rerender();
      this.employerList = null;
      this.isLoading = true;
      axios.get('/api/EmployerCompany/GetEmployerCompany')
        .then(res => {
          if (res.status != '200') {
            console.log('error.....')
            const error = new Error('Failed to fetch!');
            return error;
          }
          let respData = res.data.data;
          if (respData != 0) {
            this.employerList = respData;
            this.body.employerCompanyId = this.employerList.employerCompanyId
            this.body.companyEmail = this.employerList.companyEmail
            this.body.companyName = this.employerList.companyName
            this.body.ceoName = this.employerList.ceoName
            this.body.address = this.employerList.address
            this.body.contactNumber = this.employerList.contactNumber
            this.body.linkedInLink = this.employerList.linkedInLink;
            this.body.facebookLink = this.employerList.facebookLink;
            this.body.twitterLink = this.employerList.twitterLink;
            this.body.googlePlusLink = this.employerList.googlePlusLink;
            this.body.companyLogoAddress = this.employerList.companyLogoAddress;
            this.body.fullName = this.employerList.employee.fullName
            this.body.designation = this.employerList.employee.designation;
            this.body.mobileNumber = this.employerList.employee.mobileNumber;
            this.body.email = this.employerList.employee.email;
            this.disEmployeeLogo = this.employerList.employee.employeeImage;
            this.allJobsList = this.employerList.jobs;
            this.showDashboard = true;
          } else {
            this.showCompleteProfileAlert = true;
            this.showDashboard = false;
          }
          this.isLoading = false;
        }).catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    getGraphData() {
      this.rerender();
      const formData = new FormData();
      formData.append("startDate", this.chartStartDate);
      formData.append("endDate", this.chartEndDate);

      if (!this.chartStartDate || !this.chartEndDate) {
        alert("Please select both start and end dates.");
        return;
      }
      this.isLoading = true;
      axios.post('/api/EmployerCompany/DashboardGraphs', formData)
        .then(res => {
          if (res.status != '200') {
            console.log('error.....')
            const error = new Error('Failed to fetch!');
            return error;
          }
          let respData = res.data.data;
          this.dashboardData = respData;
          this.dashboardData.cVsRecievedOnJobs = this.dashboardData.cVsRecievedOnJobs.filter(item => item.count !== 0);
          this.series = [];
          respData.genderBaseApplicants.forEach(element => {
            if (element.maleApplicantCount != 0) {
              this.series.push(element.maleApplicantCount);
            } else {
              this.series.push(0);
            }
            if (element.femaleApplicantCount != 0) {
              this.series.push(element.femaleApplicantCount);
            } else {
              this.series.push(0);
            }
            if (element.transGenderApplicantCount != 0) {
              this.series.push(element.transGenderApplicantCount);
            } else {
              this.series.push(0);
            }
          });
          this.lineChartOptions.xaxis.categories = [];
          this.lineChartSeries[0].data = [];
          let x = 1;
          respData.jobApplicationsAgainstJobs.forEach(element => {
            this.lineChartOptions.xaxis.categories.push(x);
            x++;
            this.lineChartSeries[0].data.push(element.jobApplicantCount);
          });
          this.rerender();
          this.isLoading = false;
        }).catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    getPackagesInfo() {
      this.isLoading = true;
      axios.get('/api/EmployerJobPostPackage/GetAllJobPostPackagesByEmployeeId')
        .then(res => {
          if (res.status != '200') {
            console.log('error.....')
            const error = new Error('Failed to fetch!');
            return error;
          }
          this.packages = res.data.data;
          this.isPackageDataFetched = true;
          this.isLoading = false;
        }).catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    tutorialGuideModal() {
      this.modalTitle = "Tutorial Guide";
      this.modalcontent = "Tutorial Guide";
      this.isTutorialGuideVisible = true;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = false;
    },
    mumsBacktoWorkModal() {
      this.modalTitle = "Mums Back to Work";
      this.modalcontent = "The world comprises males and females which means both genders contribute their fair share of responsibilities...";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = true;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = false;
    },
    abledCandidatesModal() {
      this.modalTitle = "Abled Candidates";
      this.modalcontent = "Diversity is the best way for innovation...";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = true;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = false;
    },
    freshGraduateModal() {
      this.modalTitle = "Fresh Graduate";
      this.modalcontent = "The first professional experience of a student is very important...";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = true;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = false;
    },
    remoteModal() {
      this.modalTitle = "Remote & Flexible Internship Program";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = true;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = false;
    },
    viiLearnModal() {
      this.modalTitle = "Vii Learn";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = true;
      this.isShehriDirectoryVisible = false;
    },
    shehriDirectoryModal() {
      this.modalTitle = "Shehri Directory";
      this.isTutorialGuideVisible = false;
      this.isMumsBacktoWorkVisible = false;
      this.isAbledCandidatesVisible = false;
      this.isFreshGraduateVisible = false;
      this.isRemoteVisible = false;
      this.isViiLearnVisible = false;
      this.isShehriDirectoryVisible = true;
    },
    rerender() {
      this.componentKey += 1;
    },
  },
  mounted() {
    this.getAdds();
    this.getAll();
    this.getPackagesInfo();
    this.getProfileInfo(1);
    this.getJobInfo(3);
    this.getGraphData();
  },
};
</script>

<style scoped>
.adsclass {
  width: 100%;
}
.custom-modal .modal-dialog {
  max-width: 60%;
}
@media screen and (max-width: 720px) {
  .adsclass {
    width: 200px;
  }
  .custom-modal .modal-dialog {
    max-width: 90%;
  }
}
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.card h5 {
  font-weight: bold;
}
.card .btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}
.card .badge-primary {
  background-color: #007bff;
}
.form-control {
  width: 40% !important;
}

/* Skeleton Loading Styles */
.skeleton {
  background: #e0e0e0;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.skeleton-alert {
  height: 60px;
  margin-bottom: 15px;
}
.skeleton-card {
  height: 350px;
}
.skeleton-search {
  height: 100px;
}
.skeleton-stats-card {
  height: 150px;
  border-radius: 8px;
}
.skeleton-applicant {
  height: 120px;
  border-radius: 10px;
  margin-bottom: 10px;
}
.skeleton-chart {
  height: 400px;
  border-radius: 8px;
}
.skeleton-job {
  height: 250px;
  border-radius: 8px;
  margin-bottom: 15px;
}
</style>